import { ConstantsLogger } from '@shared/logger/constants_logger';
import { ILogMessageParams } from '@shared/logger/i_log_message_params';
import { ServiceLoggerBase } from '@shared/logger/service_logger_base';
import { try_measure_performance_capture } from './utils_performance';

export function log_connection_terms_user(connection_id: string, namespace: string) {
  let params: ILogMessageParams = { connection_id, namespace };

  logi(`🔗 client connected`, params);
  logi('', params);
  logi('📡 s = server', params);
  logi('🖥️ c = client', params);
  logi('📩 c = response to client request', params);
  logi('👤 u = user', params);
  logi('👥 w = workspace', params);
  logi('', params);
}

export function log_connection_terms_generator(connection_id: string, namespace: string) {
  let params: ILogMessageParams = { connection_id, namespace };

  logi(`🔗 generator connected`, params);
  logi('', params);
  logi('📡 s = server', params);
  logi('🌀 g = generator', params);
  logi('📩 g = response to generator request', params);
  logi('', params);
}

const LOGGERS: ServiceLoggerBase[] = [];

export const register_logger = (logger: ServiceLoggerBase) => {
  LOGGERS.push(logger);
};

export function log_network_event(direction: string, event: string, bytes: number, params: ILogMessageParams = ConstantsLogger.PARAMS_DEFAULT) {
  params = { ...params, bytes, bytes_reference: ConstantsLogger.BYTES_NETWORK_DATA_REFERENCE };

  try_measure_performance_capture(params);

  for (let logger of LOGGERS) {
    let message = `${direction}\t${event}`;

    logger.log_info(message, params);
  }
}

export function logi(message: string, params: ILogMessageParams = ConstantsLogger.PARAMS_DEFAULT) {
  try_measure_performance_capture(params);

  for (let logger of LOGGERS) {
    logger.log_info(message, params);
  }
}

export function logw(message: string, params: ILogMessageParams = ConstantsLogger.PARAMS_DEFAULT) {
  for (let logger of LOGGERS) {
    logger.log_warning(message, params);
  }
}

export function loge(message: string, params: ILogMessageParams = ConstantsLogger.PARAMS_DEFAULT) {
  for (let logger of LOGGERS) {
    logger.log_error(message, params);
  }
}

export function log_app_version(version: string, build_time: string, build_timestamp: number) {
  logi(`😎 app version:\t\t\t\t${version}`);
  logi(`🛠️ app build time:\t\t\t\t${build_time}`);
  logi(`⏱️ app build timestamp:\t\t${build_timestamp}`);
}
